// Mock data for Starnight Holdings

export const companyInfo = {
  name: "Starnight Holdings",
  tagline: "Building Excellence Across Virtual Worlds",
  description: "Starnight Holdings is a premier hospitality and business management company operating exceptional establishments across the Roblox platform. We pride ourselves on delivering outstanding experiences, fostering professional growth, and maintaining the highest standards of service excellence.",
  mission: "Our mission is to create immersive, professional, and engaging experiences that set new standards in virtual hospitality and business management.",
  values: [
    "Excellence in Service",
    "Professional Development",
    "Community Engagement",
    "Innovation & Growth"
  ]
};

export const currentGroups = [
  {
    id: 1,
    name: "Greggs PLC",
    description: "A beloved bakery chain delivering quality baked goods and exceptional customer service.",
    type: "Food & Beverage",
    image: "https://customer-assets.emergentagent.com/job_starnight-group/artifacts/clusy07k_greggs2027.webp",
    link: "https://www.roblox.com/communities/10341599/Greggs-PLC-UK#!/about",
    fullDescription: "Greggs PLC is a renowned bakery chain that has become a staple in the virtual world. We pride ourselves on delivering freshly baked goods, exceptional customer service, and a warm, welcoming environment. Our team is dedicated to maintaining the highest standards of quality and ensuring every customer leaves satisfied. Join us for a delightful experience that combines tradition with innovation."
  },
  {
    id: 2,
    name: "Hurlingham Academy",
    description: "Premier educational institution focused on professional training and development.",
    type: "Education",
    image: "https://customer-assets.emergentagent.com/job_starnight-group/artifacts/u8ror3qz_hurlingham.png",
    link: "https://www.roblox.com/communities/32625580/THA-The-Hurlingham-Academy#!/about",
    fullDescription: "The Hurlingham Academy stands as a beacon of excellence in education and professional development. We offer comprehensive training programs designed to equip individuals with the skills and knowledge needed to excel in their careers. Our experienced instructors and state-of-the-art facilities create an environment where learning thrives. Whether you're starting your journey or advancing your expertise, Hurlingham Academy is your partner in success."
  },
  {
    id: 3,
    name: "The Royal Oak",
    description: "Traditional pub experience with warm hospitality and community atmosphere.",
    type: "Hospitality",
    image: "https://customer-assets.emergentagent.com/job_starnight-group/artifacts/hkg2b5r2_tro1.webp",
    link: "https://www.roblox.com/communities/35254057/TRO-The-Royal-Oak#!/about",
    fullDescription: "The Royal Oak offers a quintessential pub experience that blends traditional charm with modern hospitality. Our establishment is known for its warm, inviting atmosphere where community members gather to enjoy quality beverages, engaging conversations, and memorable moments. With a dedicated team committed to exceptional service, The Royal Oak has become a beloved destination for those seeking authentic hospitality and a sense of belonging."
  },
  {
    id: 4,
    name: "Morriblox UK",
    description: "Leading retail establishment providing quality products and outstanding service.",
    type: "Retail",
    image: "https://customer-assets.emergentagent.com/job_starnight-group/artifacts/rlisl7so_morriblox101.webp",
    link: "https://www.roblox.com/communities/14242980/Morriblox-UK#!/about",
    fullDescription: "Morriblox UK is a premier retail destination offering an extensive range of quality products and unparalleled customer service. Our commitment to excellence is reflected in every aspect of our operations, from our carefully curated product selection to our knowledgeable and friendly staff. We strive to create a shopping experience that exceeds expectations, making Morriblox UK the go-to choice for discerning customers seeking both value and quality."
  },
  {
    id: 5,
    name: "Starbucks",
    description: "Premium coffeehouse experience with world-class beverages and warm atmosphere.",
    type: "Café",
    image: "https://customer-assets.emergentagent.com/job_teamstarnight/artifacts/iv4qlvud_starbucks101.PNG",
    link: "https://www.roblox.com/communities/35548340/Starbuck-s-Roblox",
    fullDescription: "Starbucks brings the authentic coffeehouse experience to the virtual world. Our establishment offers premium beverages, a welcoming atmosphere, and exceptional service that has made Starbucks a global icon. From expertly crafted coffees to refreshing teas, every drink is prepared with care and passion. Join us for an unforgettable café experience where quality meets community."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Bella T.",
    role: "Chief Executive Officer",
    roleShort: "CEO",
    avatar: "https://customer-assets-39nsmqrw.emergentagent.net/job_209c8813-566e-47da-85c4-1d1fadce8833/artifacts/dg6zknpv_image.png",
    bio: "Leading Starnight Holdings with vision and dedication to excellence.",
    fullBio: "Bella is the founder and Chief Executive Officer of Starnight Holdings. She set the company's vision from day one — to build a multi-establishment group on Roblox that puts people, service, and innovation first. Her hands-on leadership style and obsession with quality have shaped every part of the business, from staff culture to customer experience.",
    focusAreas: ["Strategic vision", "Brand identity", "Senior leadership", "Investor relations"],
    joinedYear: 2023,
    achievements: ["Founded Starnight Holdings", "Scaled to 5+ establishments", "Built leadership team of 6 C-suite officers"],
    quote: "Hospitality is a craft. We treat it as such — every day, every shift, every detail.",
    contact: { email: "bella@starnightholdings.uk" }
  },
  {
    id: 2,
    name: "Kayla",
    role: "Chief Financial Officer",
    roleShort: "CFO",
    avatar: "https://customer-assets.emergentagent.com/job_starnight-group/artifacts/n4aaqshe_valindraa.webp",
    bio: "Ensuring financial stability and strategic growth across all holdings.",
    fullBio: "Kayla leads Starnight's financial strategy — from budgeting and forecasting to capital allocation across every establishment. She turns numbers into decisions, making sure the group grows sustainably while every venue stays profitable and well-resourced.",
    focusAreas: ["Financial planning", "Group budgeting", "Capital allocation", "Risk management"],
    joinedYear: 2023,
    achievements: ["Unified financial reporting across the group", "Negotiated key supplier contracts", "Maintained profitability across all venues"],
    quote: "Discipline with money is discipline with everything else.",
    contact: { email: "kayla@starnightholdings.uk" }
  },
  {
    id: 3,
    name: "Denis",
    role: "Chief Operating Officer",
    roleShort: "COO",
    avatar: "https://customer-assets.emergentagent.com/job_starnight-group/artifacts/1lot5hem_denisp101.webp",
    bio: "Overseeing daily operations and maintaining excellence standards.",
    fullBio: "Denis is the engine room — turning Bella's vision into daily reality. He oversees operations across every venue, ensuring service standards are uniform, staff are supported, and processes scale as the group grows.",
    focusAreas: ["Operations excellence", "Cross-venue standards", "Supply chain", "Staff readiness"],
    joinedYear: 2023,
    achievements: ["Standardised SOPs across 5 venues", "Cut response times by 40%", "Led group-wide quality programme"],
    quote: "Consistency is the foundation of luxury.",
    contact: { email: "denis@starnightholdings.uk" },
    tags: [{ label: "DMCA Lead", color: "violet" }]
  }
];

export const vacancies = [
  {
    id: 1,
    title: "Senior Manager",
    department: "Operations",
    location: "Various Locations",
    type: "Full-time",
    description: "Lead and manage daily operations across our establishments."
  },
  {
    id: 2,
    title: "Customer Service Representative",
    department: "Hospitality",
    location: "The Royal Oak",
    type: "Part-time",
    description: "Deliver exceptional customer service and create memorable experiences."
  },
  {
    id: 3,
    title: "Training Coordinator",
    department: "Human Resources",
    location: "Hurlingham Academy",
    type: "Full-time",
    description: "Develop and deliver training programs for staff development."
  },
  {
    id: 4,
    title: "Retail Associate",
    department: "Retail",
    location: "Morriblox UK",
    type: "Part-time",
    description: "Assist customers and maintain store standards."
  }
];

export const staffMembers = [
  {
    id: 1,
    name: "Matthew",
    role: "PA to Chief Executive Officer",
    department: "executive-support",
    bio: "Supporting the CEO with executive coordination and ensuring seamless day-to-day operations.",
    initials: "MW"
  },
  {
    id: 2,
    name: "Anastasia",
    role: "People Manager",
    department: "people",
    bio: "Leading our people operations with passion and dedication to team development.",
    initials: "AN",
    tags: [{ label: "DMCA Officer", color: "violet" }]
  },
  {
    id: 4,
    name: "Edward",
    role: "Customer Relations Executive",
    department: "community",
    bio: "Committed to providing excellent customer experiences and resolving inquiries efficiently.",
    initials: "ED"
  },
  {
    id: 6,
    name: "Aidan",
    role: "People Executive",
    department: "people",
    bio: "Supporting staff development and ensuring team satisfaction across all groups.",
    initials: "AD"
  },
  {
    id: 7,
    name: "Charlotte",
    role: "Customer Relations Manager",
    department: "community",
    bio: "Leading customer relations and ensuring every guest receives a five-star experience.",
    initials: "CH"
  },
  {
    id: 8,
    name: "Aaron",
    role: "Head of Group Operations",
    department: "ops",
    bio: "Driving operational excellence and overseeing performance across all Starnight establishments.",
    initials: "AR"
  },
  {
    id: 9,
    name: "Jess",
    role: "Operations Manager",
    department: "ops",
    bio: "Orchestrating seamless day-to-day operations and ensuring excellence across every touchpoint.",
    initials: "JE"
  },
  {
    id: 11,
    name: "Corey",
    role: "Community Manager",
    department: "community",
    bio: "Building vibrant community connections and curating engaging experiences across our spaces.",
    initials: "CO"
  },
  {
    id: 12,
    name: "Crumms",
    role: "Operations Executive",
    department: "ops",
    bio: "Driving operational excellence and ensuring smooth execution across all venues.",
    initials: "CR"
  },
  {
    id: 13,
    name: "Stacey",
    role: "Customer Relations Executive",
    department: "community",
    bio: "Championing customer satisfaction and delivering thoughtful, personalised service.",
    initials: "ST"
  }
];

export const contactInfo = {
  generalEmail: "help@starnightholdings.uk",
  recruitmentEmail: "recruitment@starnightholdings.uk",
  discord: "https://discord.gg/2PFMA3hKjW",
  socialMedia: {
    roblox: "Starnight Holdings"
  }
};